// react-native-web's Alert.alert is a no-op stub (it never shows anything),
// so web builds need their own implementation to actually surface feedback.
export function notify(title: string, message?: string) {
  window.alert(message ? `${title}\n\n${message}` : title);
}
